export default __webpack_public_path__ + "static/media/takeout_containers.cefd94ba.png";